import {Button, Typography,} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import FileInput from "../../system/fileInput";
import "../../../style/datePicker.css"
import {Toaster} from "../../../helper/Toaster";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import {updateBackOfficeAgentRequestFile} from "../../../services/back_office/agent";
import {checkAll} from "../../../helper/validator/Check";


export function BackOfficeAgentRequestFile({
                                             activeStep,
                                             setActiveStep,
                                             agentRequest,
                                             setAgentRequest,
                                             handleNext,
                                             handlePrev,
                                             isFirstStep,
                                             isLastStep,
                                             agentLog,
                                             setAgentLog,
                                             person_id
                                           }) {

  const [id, setId] = useState(null);
  const [degreeFile, setDegreeFile] = useState({name: ""})
  const [degreeFileName, setDegreeFileName] = useState("")
  const [resumeFile, setResumeFile] = useState({name: ""})
  const [resumeFileName, setResumeFileName] = useState("")
  const [introductionFile, setIntroductionFile] = useState({name: ""})
  const [introductionFileName, setIntroductionFileName] = useState("")
  const [personId, setPersonId] = useState(null);

  useEffect(() => {
    setPersonId(person_id);
  }, [person_id]);

  useEffect(() => {
    setDegreeFileName(degreeFile['name'])
  }, [degreeFile]);

  useEffect(() => {
    setResumeFileName(resumeFile['name'])
  }, [resumeFile]);

  useEffect(() => {
    setIntroductionFileName(introductionFile['name'])
  }, [introductionFile]);

  useEffect(() => {
    if (!agentRequest || !agentRequest.id) {
      return
    }
    setAgentRequest(agentRequest);
    setId(agentRequest.id);
    setDegreeFile((agentRequest && agentRequest.degree_file && agentRequest.degree_file.String) || {name: ""});
    setResumeFile((agentRequest && agentRequest.resume_file && agentRequest.resume_file.String) || {name: ""});
    setIntroductionFile((agentRequest && agentRequest.introduction_file && agentRequest.introduction_file.String) || {name: ""});
  }, []);

  const save = async () => {
    const data = {
      id: id,
      degree_file: degreeFile,
      resume_file: resumeFile,
      introduction_file: introductionFile,
      person_id: personId,
    };
    const res = checkAll();
    if (!res) {
      Toaster.failure(null,
        <Typography variant="small">
          مقادیر الزامی را بر اساس راهنما تکمیل کنید
        </Typography>);
      return
    }
    let result;

    result = await updateBackOfficeAgentRequestFile(data);

    if (result.status === 200) {
      setAgentLog(
        {
          agent_id: agentRequest.id,
          status: "new",
        }
      )
      setActiveStep(0)
    }
  };

  return (
    <ValidatorProvider>
      <>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xxl:grid-cols-2">

          <div className="flex flex-col w-full mb-4">
            <FileInput
              label={Dict('degree_file')}
              fileCode={degreeFile}
              onChange={(e) => {
                setDegreeFile(e.target.files[0]);
              }}/>
            {/*<Validator state={degreeFileName} rules="required"/>*/}
          </div>

          <div className="flex flex-col w-full mb-4">
            <FileInput
              label={Dict('resume_file')}
              fileCode={resumeFile}
              onChange={(e) => {
                setResumeFile(e.target.files[0]);
              }}/>
            {/*<Validator state={resumeFileName} rules="required"/>*/}
          </div>

          <div className="flex flex-col w-full mb-4">
            <FileInput
              label={Dict('introduction_file')}
              fileCode={introductionFile}
              onChange={(e) => {
                setIntroductionFile(e.target.files[0]);
              }}/>
            {/*<Validator state={introductionFile} rules="required"/>*/}
          </div>

        </div>
        <div className="justify-between">
          <div className="mt-32 flex justify-between">
            <Button onClick={save}>
              ارسال جهت بررسی
            </Button>
            <Button onClick={() => {
              handlePrev(2)
            }} disabled={isFirstStep}>
              مرحله قبلی
            </Button>
          </div>
        </div>
      </>
    </ValidatorProvider>
  )
    ;
}